import apiClient from 'helpers/api-client'
import { API_USER } from 'routes/apis'
import { DataResponse } from '~/@types/commons'
import { GetOrganizationsResponse } from './interface'

export const getOrganizations =
  async (): Promise<GetOrganizationsResponse> => {
    const res = await apiClient.get<DataResponse<GetOrganizationsResponse>>(
      API_USER.organizations,
    )
    return res.data.data
  }
